<script setup>
import { useI18n } from 'vue-i18n';
import { formatDistanceToNow } from 'date-fns';

import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  identities: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['connect', 'archive', 'add-another', 'close']);

const { t } = useI18n();

const lastUsedLabel = identity => {
  if (!identity.last_used_at) {
    return t('CONVERSATION.REMOTE_SUPPORT.NEVER_USED');
  }
  return t('CONVERSATION.REMOTE_SUPPORT.LAST_USED', {
    relative: formatDistanceToNow(new Date(identity.last_used_at), {
      addSuffix: true,
    }),
  });
};
</script>

<template>
  <div
    class="remote-control-dropdown absolute top-full mt-1 ltr:right-0 rtl:left-0 z-50 min-w-[280px] max-w-[360px] bg-n-alpha-3 backdrop-blur-[100px] border-0 outline outline-1 outline-n-container rounded-xl shadow-lg py-2"
    @click.stop
  >
    <ul class="reset-base flex flex-col">
      <li
        v-for="identity in identities"
        :key="identity.id"
        class="flex items-center gap-2 px-2 hover:bg-n-alpha-1 dark:hover:bg-n-alpha-2 rounded-lg mx-1"
      >
        <button
          type="button"
          class="flex-1 min-w-0 text-left py-2 px-2 bg-transparent border-0"
          @click="$emit('connect', identity)"
        >
          <div class="text-sm font-medium text-n-slate-12 truncate">
            {{
              identity.label ||
              t('CONVERSATION.REMOTE_SUPPORT.UNLABELED')
            }}
          </div>
          <div class="text-xs text-n-slate-11 truncate">
            {{ identity.rustdesk_id }} - {{ lastUsedLabel(identity) }}
          </div>
        </button>
        <button
          type="button"
          class="flex-shrink-0 p-1.5 rounded-md hover:bg-n-alpha-2 bg-transparent border-0 text-n-slate-11 hover:text-n-ruby-11"
          :aria-label="t('CONVERSATION.REMOTE_SUPPORT.ARCHIVE')"
          :title="t('CONVERSATION.REMOTE_SUPPORT.ARCHIVE')"
          @click.stop="$emit('archive', identity)"
        >
          <Icon icon="i-lucide-trash-2" class="size-4" />
        </button>
      </li>
      <li class="border-t border-n-alpha-2 mt-1 pt-1">
        <button
          type="button"
          class="w-full text-left px-3 py-2 text-sm text-n-blue-11 hover:bg-n-alpha-1 dark:hover:bg-n-alpha-2 rounded-lg mx-1 bg-transparent border-0 inline-flex items-center gap-2"
          @click="$emit('add-another')"
        >
          <Icon icon="i-lucide-plus" class="size-3.5" />
          {{ t('CONVERSATION.REMOTE_SUPPORT.ADD_ANOTHER') }}
        </button>
      </li>
    </ul>
  </div>
</template>
